import { render, staticRenderFns } from "./RTBDestinationForm.vue?vue&type=template&id=8cf28336"
import script from "./RTBDestinationForm.vue?vue&type=script&lang=js"
export * from "./RTBDestinationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports